// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3TRVY","footer":"ReportModalFilter_footer__1RFpo"};